import { primaryKey, headerCode, inputType, required, length, order, pattern, editable, Describer, GceEntity } from './gce-management';

export class GceArea extends GceEntity {
    @headerCode('GCE.GCEAREA.AREAID')
    @inputType('number')
    @order(1)
    AreaId: number;

    @headerCode('GCE.GCEAREA.AREADESCRIZIONE')
    @inputType('text')
    @length(255)
    @order(2)
    AreaDescrizione: string;

    @headerCode('GCE.GCEAREA.DISTRICTID')
    @inputType('number')
    @order(3)
    DistrictId: number;

    constructor();
    constructor(AreaId: number, AreaDescrizione: string, DistrictId:number );
    constructor(AreaId?: number, AreaDescrizione?: string, DistrictId?:number ){
        super();
        this.AreaId = AreaId;
        this.AreaDescrizione = AreaDescrizione || '';
        this.DistrictId = DistrictId;
       
    }

    static getStructure():Array<any>{
        let structure:any[] = Describer.getStructure(new GceArea());
        structure.push(...this.getActions());
        return structure;
    }

    protected static getActions():any[]{
        let actions:any[] = [];
        return actions;
    }
}